/**
 * Insights brand lift study (plans/insights-brand-lift-relaunch.md, build
 * design 2026-10-14; no-wait targeting 2026-11-04).
 *
 * The auth host buckets each Insights reader per live study: `h` (holdout)
 * or `t` (test). The SDK caches that assignment, sends the bucket to GAM as
 * the study's key-value (`nbls`) on every display request and Stories ad tag,
 * and counts campaign exposure in the shared ad runtime
 * (lib/insights/study.js). A study's line items target `nbls is any of t, o`,
 * so a request without the key-value can never serve the campaign. Ads
 * therefore never wait for the assignment: the bucket joins the page's
 * targeting when it arrives. Edit here and rebuild the SDK.
 */
module.exports = {
  STUDY_ASSIGNMENT_PATH: '/api/insights/study/v1/assignments',
  // Used when an assignment names no key-value of its own.
  STUDY_DEFAULT_TARGETING_KEY: 'nbls',
  // Sent on the default key for a reader this page keeps out of every study
  // (ads consent DENIED), so the campaign can still serve them. Never a
  // bucket: the study's line items target `t` or this value.
  STUDY_OUT_OF_STUDY_VALUE: 'o',
  // `milla_study:<brand>` = { v, fetchedAt, ttlMs, anonId, studies }.
  STUDY_ASSIGNMENT_STORAGE_PREFIX: 'milla_study:',
  STUDY_ASSIGNMENT_CACHE_VERSION: 1,
  // A fresh entry applies without a request; a stale one still applies at
  // once and is refreshed in the background. The response's ttlSeconds can
  // shorten this, never extend it.
  STUDY_ASSIGNMENT_TTL_MS: 6 * 60 * 60 * 1000,
  // `milla_study_exposure:<brand>:<studyKey>` = exposure counters.
  STUDY_EXPOSURE_STORAGE_PREFIX: 'milla_study_exposure:',
  // Survey selection waits at most this long for this page's ads to settle a
  // study reader's group.
  STUDY_GROUP_WAIT_MS: 3000,
  // Ad events seen before the first assignment arrives, kept in memory.
  STUDY_MAX_PENDING_EVENTS: 100
};
